export default "__VITE_ASSET__586ace04__"